import { __assign, __rest } from "tslib";
/* eslint-disable */

/* tslint:disable */

import React from 'react';

var pause = function pause(_a) {
  var size = _a.size,
      props = __rest(_a, ["size"]);

  return React.createElement("svg", __assign({
    viewBox: "0 0 10 14",
    fill: "currentColor",
    width: size || "10",
    height: size || "14"
  }, props), React.createElement("g", {
    id: "final",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Play",
    transform: "translate(-490 -763)",
    fill: "currentColor"
  }, React.createElement("g", {
    id: "Group-2",
    transform: "translate(470 284)"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(20 479)"
  }, React.createElement("path", {
    d: "M7,0 L10,0 L10,14 L7,14 L7,0 Z M0,0 L3,0 L3,14 L0,14 L0,0 Z",
    id: "_copy_3"
  }))))));
};

pause.displayName = 'pause';
export default pause;
/* tslint:enable */

/* eslint-enable */